import React, { useState } from "react";
import { BiSolidCloudUpload } from "react-icons/bi";
import { CiCircleRemove } from "react-icons/ci";
import { FaEdit, FaPen, FaTrash } from "react-icons/fa";
import { Card, Col, Container, Input, Row } from "reactstrap";
import CropModal from "./CropModal";
import { v4 as uuidv4 } from "uuid";

const SmallSizeMomento = (props) => {
    const {
        momento,
        setMomento,
        QRCODES,
        setQRCODES,
        setMediaToRemove,
        setQRMediaRemove,
    } = props;
    const [cropModal, setCropModal] = useState(false);
    const [indexToOpen, setIndexToOpen] = useState(-1);

    // const [imagePreviews, setImagePreviews] = useState([]);

    const handleUploadClick = (index) => {
        const fileInput = document.getElementById(`upload-button-${index}`);
        fileInput.click();
    };

    const handleFileChange = (e, index) => {
        if (e.target.files.length) {
            setMomento((prevState) => {
                const newMomento = [...prevState];
                newMomento[index].media = e.target.files[0];
                return newMomento;
            });
        }
    };

    const handleQRUploadClick = (qrIdx) => {
        const fileInput = document.getElementById(`upload-button-QR1-${qrIdx}`);
        if (fileInput) {
            fileInput.click();
        }
    };
    const replaceCroppedImage = async (index, newCroppedImage) => {
        const UUID = uuidv4();
        try {
            const response = await fetch(newCroppedImage);
            const blob = await response.blob();

            setMomento((prevState) => {
                const newMomento = [...prevState];
                newMomento[index].media = new File(
                    [blob],
                    `${UUID + "_" + newMomento[index].title}.jpeg`
                );
                return newMomento;
            });
            setCropModal(false);
        } catch (error) {
            console.error("Error fetching blob data:", error);
        }
    };

    const handleQRFileChange = (e, qrIdx) => {
        const file = e.target.files[0];
        if (file) {
            setQRCODES((prevCodes) => {
                const updatedCodes = [...prevCodes];
                updatedCodes[qrIdx] = file;
                return updatedCodes;
            });
        }
    };

    const handleQRRemove = (qrIdx, media) => {
        if (media instanceof File) {
            setQRCODES((prevCodes) => {
                const updatedCodes = [...prevCodes];
                updatedCodes[qrIdx] = "";
                return updatedCodes;
            });
        } else {
            setQRCODES((prevCodes) => {
                const updatedCodes = [...prevCodes];
                updatedCodes[qrIdx] = "";
                return updatedCodes;
            });
            setQRMediaRemove((prev) => [...prev, media]);
        }
    };

    const removeMediaImgs = (index, media) => {
        if (media instanceof File) {
            setMomento((prevState) => {
                const newMomento = [...prevState];
                newMomento[index].media = "";
                return newMomento;
            });
        } else {
            setMomento((prevState) => {
                const newMomento = [...prevState];
                newMomento[index].media = "";
                return newMomento;
            });
            setMediaToRemove((prev) => [...prev, media]);
        }
    };
    // console.log({ mediaToRemove });

    const handleTextChange = (e, index) => {
        const { name, value } = e.target;
        setMomento((prevState) => {
            const newMomento = [...prevState];
            newMomento[index][name] = value;
            return newMomento;
        });
    };
    // const setCroppedImage = (index, img) => {
    //     console.log({ index, img });
    // };
    return (
        <Container className="d-flex flex-column momento__media">
            <Row className="p-3 flex-nowrap">
                {/* QRCODES First Column */}
                <Col className="col-1 d-flex flex-column justify-content-around pt-5 mr-1 pl-0 momento__media-qrCode_col">
                    {QRCODES?.map((qrCode, qrIdx) => {
                        if (qrIdx == 0 || qrIdx == 1) {
                            return (
                                <>
                                    {qrCode !== "" ? (
                                        <div className="position-relative">
                                            <img
                                                src={
                                                    qrCode instanceof File
                                                        ? URL.createObjectURL(
                                                              qrCode
                                                          )
                                                        : qrCode
                                                }
                                                className="w-100 create_momento-QR_img"
                                                alt={`QR Code ${qrIdx}`}
                                            />
                                            <CiCircleRemove
                                                className="QR-code-remove"
                                                onClick={() =>
                                                    handleQRRemove(
                                                        qrIdx,
                                                        qrCode
                                                    )
                                                }
                                            />
                                        </div>
                                    ) : (
                                        <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center">
                                            <BiSolidCloudUpload
                                                className="create_momento-qrcode_div__upload-icon"
                                                onClick={() =>
                                                    handleQRUploadClick(qrIdx)
                                                }
                                            />

                                            <input
                                                type="file"
                                                accept="image/*"
                                                id={`upload-button-QR1-${qrIdx}`}
                                                style={{
                                                    display: "none",
                                                }}
                                                onChange={(e) =>
                                                    handleQRFileChange(e, qrIdx)
                                                }
                                            />
                                        </div>
                                    )}
                                </>
                            );
                        }
                    })}
                </Col>
                {/* QRCODES First Column End*/}
                {momento?.map((item, index) => {
                    return (
                        <Col className="p-2 momento__media-card">
                            <Card className="w-100 p-3 create_momento-card">
                                <Input
                                    placeholder="Enter Card Title"
                                    value={item.title}
                                    type="text"
                                    name="title"
                                    maxLength={21}
                                    onChange={(e) => handleTextChange(e, index)}
                                />
                                <Input
                                    placeholder="Enter Card Subtitle"
                                    className="mt-3"
                                    value={item.subTitle}
                                    type="text"
                                    name="subTitle"
                                    maxLength={27}
                                    onChange={(e) => handleTextChange(e, index)}
                                />
                                <div className="create_momento__media-div ">
                                    {item?.media !== "" ? (
                                        <div className="w-100 position-relative d-flex justify-content-center align-items-center">
                                            <img
                                                src={
                                                    item.media instanceof File
                                                        ? URL.createObjectURL(
                                                              item.media
                                                          )
                                                        : item.media
                                                }
                                                alt="img"
                                                className="w-100 create_momento__media-div_img"
                                            />
                                            {item.media instanceof File && (
                                                <div
                                                    className="edit_icon"
                                                    onClick={() => {
                                                        setCropModal(true);
                                                        setIndexToOpen(index);
                                                    }}
                                                >
                                                    <FaPen />
                                                </div>
                                            )}
                                            {cropModal &&
                                            indexToOpen === index ? (
                                                <CropModal
                                                    index={index}
                                                    imageUrl={
                                                        item.media instanceof
                                                        File
                                                            ? URL.createObjectURL(
                                                                  item.media
                                                              )
                                                            : item.media
                                                    }
                                                    cropInit={item?.crop}
                                                    zoomInit={item?.zoom}
                                                    aspectInit={item?.aspect}
                                                    setCroppedImage={
                                                        replaceCroppedImage
                                                    }
                                                />
                                            ) : null}
                                            <div
                                                className="trash_icon"
                                                onClick={() =>
                                                    removeMediaImgs(
                                                        index,
                                                        item?.media
                                                    )
                                                }
                                            >
                                                <FaTrash />
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <BiSolidCloudUpload
                                                className="create_momento__media-div__upload_icon text-white"
                                                onClick={() =>
                                                    handleUploadClick(index)
                                                }
                                            />
                                            <input
                                                type="file"
                                                accept="image/*"
                                                id={`upload-button-${index}`}
                                                style={{
                                                    display: "none",
                                                }}
                                                onChange={(e) =>
                                                    handleFileChange(e, index)
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                                <br />
                            </Card>
                        </Col>
                    );
                })}
                {/* QRCODES second Column */}
                <Col className="col-1 d-flex flex-column-reverse  justify-content-around pt-5 pr-0 momento__media-qrCode_col">
                    {QRCODES?.map((qrCode, qrIdx) => {
                        if (qrIdx === 7 || qrIdx === 8) {
                            return (
                                <>
                                    {qrCode !== "" ? (
                                        <div className="position-relative">
                                            <img
                                                src={
                                                    qrCode instanceof File
                                                        ? URL.createObjectURL(
                                                              qrCode
                                                          )
                                                        : qrCode
                                                }
                                                className="w-100 create_momento-QR_img"
                                                alt={`QR Code ${qrIdx}`}
                                            />

                                            <CiCircleRemove
                                                className="QR-code-remove"
                                                onClick={() =>
                                                    handleQRRemove(
                                                        qrIdx,
                                                        qrCode
                                                    )
                                                }
                                            />
                                        </div>
                                    ) : (
                                        <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center">
                                            <BiSolidCloudUpload
                                                className="create_momento-qrcode_div__upload-icon"
                                                onClick={() =>
                                                    handleQRUploadClick(qrIdx)
                                                }
                                            />

                                            <input
                                                type="file"
                                                accept="image/*"
                                                id={`upload-button-QR1-${qrIdx}`}
                                                style={{
                                                    display: "none",
                                                }}
                                                onChange={(e) =>
                                                    handleQRFileChange(e, qrIdx)
                                                }
                                            />
                                        </div>
                                    )}
                                </>
                            );
                        }
                    })}
                </Col>
                {/* QRCODES second Column Ends */}
            </Row>
            {/* QRCODES Row */}
            <Row className="d-flex justify-content-between align-items-center mx-0 px-0 my-3 flex-nowrap">
                {QRCODES?.map((qrCode, qrIdx) => {
                    if (qrIdx > 1 && qrIdx < 7) {
                        return (
                            <div className="momento__media-qrCode_row">
                                {qrCode !== "" ? (
                                    <div className="position-relative">
                                        <img
                                            src={
                                                qrCode instanceof File
                                                    ? URL.createObjectURL(
                                                          qrCode
                                                      )
                                                    : qrCode
                                            }
                                            className="w-100 create_momento-QR_img"
                                            alt={`QR Code ${qrIdx}`}
                                        />
                                        <CiCircleRemove
                                            className="QR-code-remove"
                                            onClick={() =>
                                                handleQRRemove(qrIdx, qrCode)
                                            }
                                        />
                                    </div>
                                ) : (
                                    <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center">
                                        <BiSolidCloudUpload
                                            className="create_momento-qrcode_div__upload-icon"
                                            onClick={() =>
                                                handleQRUploadClick(qrIdx)
                                            }
                                        />

                                        <input
                                            type="file"
                                            accept="image/*"
                                            id={`upload-button-QR1-${qrIdx}`}
                                            style={{
                                                display: "none",
                                            }}
                                            onChange={(e) =>
                                                handleQRFileChange(e, qrIdx)
                                            }
                                        />
                                    </div>
                                )}
                            </div>
                        );
                    }
                })}
            </Row>
            {/* QRCODES Row ENDS*/}
        </Container>
    );
};

export default SmallSizeMomento;
